import { Typography } from "@mui/material";
import { Job } from "@api/Models";
import { JobCard } from "./JobCard";
import { useTranslation } from "react-i18next";

interface ExperienceProps {
  jobs: Job[];
}

export function Experience({ jobs }: ExperienceProps) {
  const { t } = useTranslation();

  return (
    <section className="mb-8">
      <Typography variant="h3" className="text-2xl font-semibold mb-4">
        {t("experience")}
      </Typography>
      {jobs.map((job, index) => (
        <JobCard key={index} job={job} />
      ))}
    </section>
  );
}
